"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomFailedEventArgs = void 0;
const EventType_1 = require("../EventType");
class RoomFailedEventArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = EventType_1.EventType.RoomFailed;
        this.__typeName = "RoomFailed";
    }
}
exports.RoomFailedEventArgs = RoomFailedEventArgs;
